export default __webpack_public_path__ + "media/images/new-dd565dbb3758883641e4452bf1a35171.png";